// extracted by mini-css-extract-plugin
export var arrow = "_jp-1";
export var content = "_jp-0";
export var highlighted = "_jp-2";